import cn from "classnames";
import { FloatingArrow, FloatingPortal } from "@floating-ui/react";

import { PopoverProps } from "./Popover.types";

import styles from "./Popover.module.scss";

const PLACEMENTS: any = {
  "right-end": styles.popoverRightEnd,
  "left-end": styles.popoverLeftEnd,
  "bottom-start": styles.popoverBottomStart,
};

//FIXME: add typings
const Popover = ({
  className,
  triggerClassName,
  isMounted,
  refs,
  animationStyles,
  styleProps,
  mode,
  placement,
  triggerElement,
  children,
  arrowRef,
  context,
  floatingArrowProps,
  styleArrowProps,
  testId,
  getReferenceProps,
  getFloatingProps,
  onPopoverMouseDown,
}: PopoverProps) => (
  <>
    <div
      className={cn(styles.trigger, triggerClassName)}
      ref={refs.setReference}
      {...getReferenceProps({
        onClick: (event: any) => event.stopPropagation(),
      })}
      data-testid={testId}
    >
      {triggerElement({ isMounted })}
    </div>

    {isMounted && (
      <FloatingPortal>
        <div
          className={cn(styles.popover, PLACEMENTS[placement], className)}
          ref={refs.setFloating}
          style={{ ...styleProps, ...animationStyles }}
          {...getFloatingProps()}
          onMouseDown={mode === "uncontrolled" ? onPopoverMouseDown : () => { }}
        >
          {floatingArrowProps && <FloatingArrow ref={arrowRef} context={context} {...floatingArrowProps} style={{ ...styleArrowProps }} />}
          {children}
        </div>
      </FloatingPortal>
    )}
  </>
);

export default Popover;
